// ** Redux imports
import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";

// ** Types imports
import type { RootState, AppDispatch } from "./index";
import type { FlagRead } from "@/types/api/types.ts";

const usePreferencesState = () => {
  const preferencesState = useSelector((state: RootState) => state.preferences);

  return preferencesState;
};

const useEnums = () => {
  return useSelector((state: RootState) => state.enums);
};

const useFlags = (): FlagRead[] => {
  return useSelector((state: RootState) => state.flags);
};

const useCurrentUser = () => {
  return useSelector((state: RootState) => state.auth.user!);
};

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { usePreferencesState, useEnums, useCurrentUser, useFlags };
